/**
 * assets/google-reviews-badge.js
 * Gedrag van snippets/google-reviews-badge.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

window.__gcr_badge_rendered = false;
window.renderGoogleBadge = function() {
  if (window.__gcr_badge_rendered) return;
  window.__gcr_badge_rendered = true;
  if (typeof gapi !== 'undefined' && gapi.ratingbadge) {
    var container = document.getElementById('google-reviews-badge-container');
    if (container) {
      gapi.ratingbadge.render(container, {
        "merchant_id": 5746907601,
        "position": "INLINE"
      });
    }
  }
};

/* Laad Google platform.js pas als de badge in de buurt van het beeld komt (08-10-2026).
   De badge staat in de footer. Tot deze datum laadde platform.js op elke pagina meteen, en het
   iframe dat Google eerst "buiten beeld" zet (top:-10000px) landde door de footer-section als
   gepositioneerde voorouder midden in het eerste scherm: CLS 0,05 tot 0,12 op desktop. Nu laadt het
   pas binnen 600px van het beeld, en de badge zelf houdt het iframe vast (zie src/tailwind.css).
   Zonder IntersectionObserver: meteen laden, zoals vroeger. */
(function() {
  function laad() {
    if (document.querySelector('script[src*="apis.google.com/js/platform.js"]')) {
      if (typeof gapi !== 'undefined') { window.renderGoogleBadge(); }
      return;
    }
    var s = document.createElement('script');
    s.src = 'https://apis.google.com/js/platform.js?onload=renderGoogleBadge';
    s.async = true;
    document.head.appendChild(s);
  }
  var container = document.getElementById('google-reviews-badge-container');
  if (!container) return;
  if (!('IntersectionObserver' in window)) { laad(); return; }
  var io = new IntersectionObserver(function(items) {
    if (items.some(function(it) { return it.isIntersecting; })) { io.disconnect(); laad(); }
  }, { rootMargin: '600px 0px' });
  io.observe(container);
})();
